import clsx from 'clsx';
import api from 'services/api';
import PropTypes from 'prop-types';
import i18n from 'translations/langEngine';
import { InputLabel, Select } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { CommonTranslations } from 'translations/translationKeys'

/* Combo de seleção do PDV ativo (sessão) */
const ComboPDV = props => {
  const { className } = props;

  const [pdvs, setPDVs] = useState({
    pdvs: []
  });

  const [selectedPDV, setSelectedPDV] = useState(
    parseInt(sessionStorage.getItem('codPDV'), 10) || ''
  );

  const [translations, setTranslations] = useState({});

  const isMountedRef = useRef(false);

  // atualiza o PDV selecionado e persiste na sessão
  const handleChangePDV = event => {
    const value = event.target.value;

    setSelectedPDV(value);

    sessionStorage.setItem('codPDV', value);
  };

  // carrega a lista de PDVs disponíveis e as traduções dos rótulos
  useEffect(() => {
    isMountedRef.current = true;

    async function loadPDVs() {
      try {
        const response = await api.get('/pdv');

        if (response.data?.[0]) {
          sessionStorage.setItem('codPDV', response.data[0].codpdvconfig);
        }

        if (isMountedRef.current) {
          setPDVs({ pdvs: response.data });
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const termsNeeded = [CommonTranslations.LABEL_USER, CommonTranslations.LABEL_PDV];
        const trs = await i18n.fetchTerms(termsNeeded);

        if (isMountedRef.current) {
          setTranslations(trs);
        }
      } catch (error) {
        console.error('Erro ao carregar as traduções:', error);
      }
    }

    loadPDVs();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const listPDVs = pdvs.pdvs.map((pdv) => (
    <option
      key={pdv.codpdvconfig}
      value={pdv.codpdvconfig}
    >
      {pdv.descpdv}
    </option>
  ));

  const lblPDV = translations[CommonTranslations.LABEL_PDV];

  return (
    <div className={clsx(className)}>
      <InputLabel
        htmlFor="outlined-age-native-simple"
        style={{ display: (listPDVs.length > 0 ? '' : 'none') }}
      >
        {lblPDV || "Ponto de Venda"}
      </InputLabel>

      <Select
        fullWidth
        inputProps={{
          id: 'outlined-age-native-simple',
          name: 'cmbPDV'
        }}
        label=""
        native
        onChange={handleChangePDV}
        style={{ display: (listPDVs.length > 0 ? '' : 'none') }}
        value={selectedPDV}
      >
        {listPDVs}
      </Select>
    </div>
  );
};

ComboPDV.propTypes = {
  className: PropTypes.string
};

export default ComboPDV;